import { updateLocalDateTimeFormat } from "./updateLocalDateTimeFormat";
import updateLocalMailboxTimeZone from "./updateLocalMailboxTimeZone";

/**
 * Update the mailbox time zone to the OS time zone only locally for Teams Calendar.
 * Update the date and time format to the host formats only locally for Teams Calendar.
 */
export default async function updateLocalDateTimeTimezone(): Promise<void> {
    updateLocalMailboxTimeZone();
    await updateLocalDateTimeFormat("OnLoad");
}
